import { useEffect, useState } from 'react'
import type { AvailableContentTag } from 'api/experiences'
import { getAvailableContentTags } from 'api/experiences'
import { EmptyArray } from 'lib/array/arrayUtils'

function useExperienceContentTags(destinationId?: string) {
  const [tags, setTags] = useState<Array<AvailableContentTag>>(EmptyArray)
  const [fetching, setFetching] = useState(false)

  useEffect(() => {
    if (!destinationId) { setTags(EmptyArray); return }
    let cancelled = false
    setFetching(true)
    getAvailableContentTags(destinationId)
      .then(result => { if (!cancelled) setTags(result) })
      .catch(() => { if (!cancelled) setTags(EmptyArray) })
      .finally(() => { if (!cancelled) setFetching(false) })
    return () => { cancelled = true }
  }, [destinationId])

  return { tags, fetching: !!destinationId && fetching }
}

export default useExperienceContentTags
